import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../../shared/shared.module';
import {UiModule} from '../../shared/ui/ui.module';
import {MenuBarComponent} from './menu-bar.component';

@NgModule({
  imports:      [
    RouterModule,

    UiModule,
    SharedModule,
  ],
  exports:      [
    MenuBarComponent,
  ],
  declarations: [
    MenuBarComponent,
  ],
})

export class MenuBarModule {

}
